import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import Question from '../Question'
import Step from './Step'
import LastStep from './LastStep'

@inject('surveyState')
@observer
export default class StepMode extends Component {
  handleSkip = () => {
    const { surveyState } = this.props
    surveyState.currentQuestion.saveAnswer('')
    this.handleNext()
  }

  handleBack = () => {
    const { surveyState } = this.props
    surveyState.previousQuestion()
  }

  handleNext = () => {
    const { onNext, surveyState } = this.props
    const { codename } = surveyState.currentQuestion
    surveyState.continue()
    if (onNext) onNext(codename)
  }

  render() {
    const { surveyState, onFinish } = this.props
    const { currentStep, currentQuestion } = surveyState
    const onSkip = currentQuestion.isRequired ? null : this.handleSkip
    const onBack = surveyState.previousStepIndex >= 0 ? this.handleBack : null

    return surveyState.isLastStep ? (
      <LastStep
        editButton={currentStep.backButton}
        submitButton={currentStep.nextButton}
        onEdit={onBack}
        onSubmit={onFinish}
        submitting={surveyState.submitting || surveyState.isRedirecting}
        title={currentStep.title}
        description={currentStep.description}
      />
    ) : (
      <Step
        onBack={onBack}
        onSkip={onSkip}
        onNext={this.handleNext}
        onNextEnabled={currentQuestion.isValid}
      >
        <Question mapped={currentQuestion} />
      </Step>
    )
  }
}
